module.exports = __webpack_public_path__ + "img/cw10.60cb66c3.jpg";